<template>
  <vue-final-modal
    v-slot="{ params }"
    v-bind="$attrs"
    classes="modal-container"
    content-class="modal-content create-update-modal"
  >

    <div class="modal__title pb-3">
      <slot name="title"></slot>
    </div>

    <div class="modal__content">
      <slot :params="params"></slot>
    </div>

    <div class="modal__action pt-3">
      <slot name="actions" :params="params">
        <div class="row">
          <div class="col">
            <button class="btn btn-secondary w-100" @click="$emit('cancel')">Cancel</button>
          </div>
          <div class="col">
            <button class="btn btn-primary w-100" @click="$emit('confirm')">Save</button>
          </div>
        </div>
      </slot>
    </div>

  </vue-final-modal>
</template>

<script>
export default {
  name: "MainModal",
  inheritAttrs: false,
  emits: ['confirm', 'cancel']
}
</script>
